import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class ActiveFiltersHeightService {
    private heightSubject = new BehaviorSubject(0);
    height$ = this.heightSubject.asObservable();

    updateHeight(height: number) {
        this.heightSubject.next(height);
    }
}
